import { CONVERSION_FACTORS } from '../constants/calculator_constants';

export const kpsiToGPa = (kpsi: number): number => {
  const gpa = kpsi * CONVERSION_FACTORS.KSI_TO_GPA;
  return gpa;
};

export const gpaToKpsi = (gpa: number): number => {
  const conversionFactor = 1 / CONVERSION_FACTORS.KSI_TO_GPA;
  const kpsi = gpa * conversionFactor;
  return kpsi;
};

export const gpaToMpa = (gpa: number): number => {
  const mpa = gpa * CONVERSION_FACTORS.GPA_TO_MPA;
  return mpa;
};

export const mpaToGpa = (mpa: number): number => {
  const gpa = mpa / CONVERSION_FACTORS.GPA_TO_MPA;
  return gpa;
};

export const mpaToKpsi = (mpa: number): number => {
  const kpsi = mpa * CONVERSION_FACTORS.MPA_TO_KSI;
  return kpsi;
};

export const kpsiToMpa = (kpsi: number): number => {
  const mpa = kpsi / CONVERSION_FACTORS.MPA_TO_KSI;
  return mpa;
};


export default { kpsiToGPa, gpaToKpsi, gpaToMpa, mpaToGpa, mpaToKpsi, kpsiToMpa };